/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseLinkDTO interface.
 */
export function instanceOfWarehouseLinkDTO(value) {
    return true;
}
export function WarehouseLinkDTOFromJSON(json) {
    return WarehouseLinkDTOFromJSONTyped(json, false);
}
export function WarehouseLinkDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'linked': json['linked'] == null ? undefined : json['linked'],
        'childId': json['childId'] == null ? undefined : json['childId'],
        'email': json['email'] == null ? undefined : json['email'],
        'linkedAt': json['linkedAt'] == null ? undefined : (new Date(json['linkedAt'])),
    };
}
export function WarehouseLinkDTOToJSON(json) {
    return WarehouseLinkDTOToJSONTyped(json, false);
}
export function WarehouseLinkDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'linked': value['linked'],
        'childId': value['childId'],
        'email': value['email'],
        'linkedAt': value['linkedAt'] == null ? undefined : ((value['linkedAt']).toISOString()),
    };
}
